export const orderShipmentCmdStatusConst = {
  error: {
    value: "ERROR",
    title: "Błąd podczas generowania przesyłki",
  },
  in_progress: {
    value: "IN_PROGRESS",
    title: "W trakcie generowania przesyłki",
  },
  success: {
    value: "SUCCESS",
    title: "Pomyślnie utworzono przesyłkę",
  },
};

export const orderSourceConst = {
  allegro: {
    value: "ALLEGRO",
    title: "Allegro",
  },
};

export const orderStatusConst = {
  draft: {
    value: "draft",
    title: "Nowe",
  },
  negotiated: {
    value: "negotiated",
    title: "Negocjowane",
  },
  saved: {
    value: "saved",
    title: "Zapisane",
  },
  waiting_for_files: {
    value: "waiting_for_files",
    title: "Oczekuje na pliki",
  },
  waiting_for_preflight: {
    value: "waiting_for_preflight",
    title: "Oczekuje na podgląd",
  },
  waiting_for_payment: {
    value: "waiting_for_payment",
    title: "Oczekuje na płatność",
  },
  in_realization: {
    value: "in_realization",
    title: "W realizacji",
  },
  in_production: {
    value: "in_production",
    title: "W produkcji",
  },
  done: {
    value: "done",
    title: "Zrealizowane",
  },
  canceled: {
    value: "canceled",
    title: "Anulowane",
  },
  deleted: {
    value: "deleted",
    title: "Usunięte",
  },
};

export const orderPermissionsConst = {
  view: {
    value: "view_order",
    errorMsg: "Użytkownik nie ma uprawnień do podglądu zamówień!",
  },
  add: {
    value: "add_order",
    errorMsg: "Użytkownik nie ma uprawnień do dodania zamówień!",
  },
  update: {
    value: "change_order",
    errorMsg: "Użytkownik nie ma uprawnień do edycji zamówień!",
  },
  delete: {
    value: "delete_order",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania zamówień!",
  },
  send: {
    value: "send_order",
    errorMsg: "Użytkownik nie ma uprawnień do wysyłania zamówień!",
  },
  duplicate: {
    value: "duplicate_order",
    errorMsg: "Użytkownik nie ma uprawnień do duplikacji zamówień!",
  },
};

export const orderproductPermissionsConst = {
  view: {
    value: "view_orderproduct",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu pozycji zamówień!",
  },
  add: {
    value: "add_orderproduct",
    errorMsg: "Użytkownik nie ma uprawnień do dodania pozycji zamówień!",
  },
  update: {
    value: "change_orderproduct",
    errorMsg: "Użytkownik nie ma uprawnień do edycji pozycji zamówień!",
  },
  delete: {
    value: "delete_orderproduct",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania pozycji zamówień!",
  },
};

export const orderProductFilePermissionsConst = {
  view: {
    value: "view_orderproductfile",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu plików projektowych!",
  },
  add: {
    value: "add_orderproductfile",
    errorMsg: "Użytkownik nie ma uprawnień do dodania pliku projektowego!",
  },
  update: {
    value: "change_orderproductfile",
    errorMsg: "Użytkownik nie ma uprawnień do edycji pliku projektowego!",
  },
  delete: {
    value: "delete_orderproductfile",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania pliku projektowego!",
  },
};

export const sourceFilePermissionsConst = {
  view: {
    value: "view_sourcefile",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu plików źródłowych!",
  },
  add: {
    value: "add_sourcefile",
    errorMsg: "Użytkownik nie ma uprawnień do dodania pliku źródłowego!",
  },
  update: {
    value: "change_sourcefile",
    errorMsg: "Użytkownik nie ma uprawnień do edycji pliku źródłowego!",
  },
  delete: {
    value: "delete_sourcefile",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania pliku źródłowego!",
  },
};

export const invoicePermissionsConst = {
  view: {
    value: "view_invoice",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu faktur!",
  },
  add: {
    value: "add_invoice",
    errorMsg: "Użytkownik nie ma uprawnień do dodania faktury!",
  },
  update: {
    value: "change_invoice",
    errorMsg: "Użytkownik nie ma uprawnień do edycji faktury!",
  },
  delete: {
    value: "delete_invoice",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania faktury!",
  },
};

export const paymentImportPermissionsConst = {
  view: {
    value: "import_payments",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu importu wpłat!",
  },
};
